// Portfolio data — Kavyasree Bysani (sourced from Resume_Kavyasree1.pdf)
export const profile = {
  name: "Kavyasree Bysani",
  firstName: "Kavyasree",
  lastName: "Bysani",
  title: "Senior UI/UX Designer",
  location: "Hyderabad, India",
  availability: "Open to product design roles · 2026",
  tagline:
    "Senior UI/UX Designer and former IBM software engineer with 6+ years designing customer-facing digital products, enterprise platforms and data-driven interfaces — equal parts technical foundation and entrepreneurial mindset.",
  email: "kavya.kancharla.123@gmail.com",
  phone: "+91 93909 39939",
  socials: [
    {
      label: "LinkedIn",
      href: "https://www.linkedin.com/in/kavyasree-bysani-a386913b",
    },
    {
      label: "Substack",
      href: "https://kavyasreebysani.substack.com",
    },
    {
      label: "Behance",
      href: "https://www.behance.net/gallery/243274351/Grocery-Sharing-app",
    },
  ],
  stats: [
    { value: "06+", label: "Years experience" },
    { value: "−57%", label: "Task-logging time · Luvia" },
    { value: "+27pp", label: "Completion lift · FairMate" },
  ],
};

export const projects = [
  {
    id: "luvia",
    title: "Luvia",
    client: "Real Estate Intelligence Platform · AI-powered CRM",
    year: "2025",
    role: "Lead Product Designer",
    span: "lg:col-span-8",
    height: "h-[420px] lg:h-[560px]",
    tags: ["B2B SaaS", "Real Estate", "AI", "Design System"],
    cover: "/projects/luvia.png",
    caseStudyUrl:
      "https://docs.google.com/presentation/d/1aTRZ0EDUwwQN9WBzawdesbZRXqK-abHy6cQhBXUOjmE/edit?slide=id.p1#slide=id.p1",
    liveUrl: "https://lu-via.site",
    summary:
      "India’s intelligent real-estate CRM — helping builders, brokerages and property teams convert more leads, close faster, and grow smarter with the power of AI.",
    metrics: [
      { value: "−57%", label: "Task-logging time" },
      { value: "AI", label: "Lead scoring + insights" },
      { value: "360°", label: "Lead management" },
    ],
    overview:
      "Luvia restructured a fragmented enterprise CRM into a single, hierarchy-driven dashboard tailored to Indian real-estate operators — with AI lead scoring, project & inventory management, and forecasting baked in. Outcome was validated through moderated usability testing with enterprise users.",
  },
  {
    id: "fairmate",
    title: "FairMate",
    client: "Shared Grocery App between Flatmates",
    year: "2025",
    role: "Product Designer · End-to-end",
    span: "lg:col-span-4",
    height: "h-[420px] lg:h-[560px]",
    tags: ["Mobile", "Fintech", "Case Study"],
    cover: "/projects/fairmate.png",
    caseStudyImages: [
      "/casestudy/fairmate/p00.jpg",
      "/casestudy/fairmate/p01.jpg",
      "/casestudy/fairmate/p02.jpg",
      "/casestudy/fairmate/p03.jpg",
      "/casestudy/fairmate/p04.jpg",
      "/casestudy/fairmate/p05.jpg",
      "/casestudy/fairmate/p06.jpg",
      "/casestudy/fairmate/p07.jpg",
    ],
    prototypeUrl:
      "https://www.figma.com/proto/LlZSSN8bJhvPoL3SSk0pXS/capstone-project?node-id=1279-989&viewport=-539%2C560%2C0.42&t=4ZOHSf9Ox1wbanZv-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=1279%3A874&show-proto-sidebar=1&page-id=1146%3A3127",
    summary:
      "A shared-pantry + bill-splitting app for flatmates — track what is in the kitchen, who paid for what, and settle up without the awkward chat.",
    metrics: [
      { value: "62 → 89%", label: "Task completion" },
      { value: "+27pp", label: "Confirmation flow" },
    ],
    overview:
      "FairMate combines a shared grocery list with lightweight expense splitting. The redesigned add-item + settle-up flows took task completion from 62% to 89% through clearer hierarchy, calmer micro-copy and one decisive primary action per screen.",
  },
  {
    id: "airbnb",
    title: "Airbnb — Reducing Decision Anxiety at Commitment",
    client: "Airbnb · Concept case study",
    year: "2025",
    role: "Product & Visual Design",
    span: "lg:col-span-5",
    height: "h-[380px] lg:h-[460px]",
    tags: ["Product Design", "Visual Design", "Travel"],
    cover: "/projects/airbnb.jpg",
    caseStudyUrl:
      "https://kavyasreebysani.substack.com/p/airbnb-reducing-decision-anxiety",
    summary:
      "Less wondering. More wandering. A concept rethink of Airbnb’s booking moment — calming the anxiety that creeps in right before you commit.",
    metrics: [
      { value: "Read", label: "Full write-up on Substack" },
      { value: "PD + VD", label: "Product · Visual" },
    ],
    overview:
      "I dug into the micro-moments around the booking CTA — pricing transparency, host trust signals, and the small uncertainties that stall commitment. The case study walks through the research lens and the visual decisions that followed.",
  },
  {
    id: "sprout",
    title: "Sprout",
    client: "Fintech App · Personal Finance",
    year: "2024",
    role: "Product Designer · End-to-end",
    span: "lg:col-span-7",
    height: "h-[380px] lg:h-[460px]",
    tags: ["Fintech", "Mobile", "Personal Finance", "Habits"],
    cover: "/projects/sprout.png",
    caseStudyUrl:
      "https://www.figma.com/proto/36ZOjLyhamjlpCfL5VUxlL/Sprout-Fintech-App?node-id=468-87&viewport=254%2C195%2C0.06&t=rdx2HGk2jk7PdLG4-1&scaling=min-zoom&content-scaling=fixed&page-id=468%3A85",
    prototypeUrl:
      "https://www.figma.com/proto/36ZOjLyhamjlpCfL5VUxlL/Sprout-Fintech-App?node-id=358-5075&p=f&viewport=490%2C-180%2C0.05&t=EfXOWZYJLTEMushY-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=358%3A5075&page-id=0%3A1",
    summary:
      "Grow your finances, simplify your life — a habit-driven personal finance app pairing income/spend tracking with goals, streaks and quick check-ins.",
    metrics: [
      { value: "Daily", label: "Habit check-ins" },
      { value: "End-to-end", label: "Research → hi-fi proto" },
      { value: "Mobile", label: "iOS first" },
    ],
    overview:
      "Sprout reframes personal finance as a daily habit rather than a monthly chore. The flow couples lightweight income/spend tracking with goals, streaks and category check-ins so progress feels visible without feeling judgemental.",
  },
];

export const skills = {
  // Pulled directly from résumé, with "Vibe coding" added per request
  craft: [
    "End-to-end product design",
    "UX research",
    "Usability testing",
    "Information architecture",
    "Interaction design",
    "User journey mapping",
    "Wireframing & prototyping",
    "Design systems",
    "Developer handoff",
    "Vibe coding",
  ],
  tools: [
    "Figma (advanced)",
    "Auto-layout & variables",
    "Components & libraries",
    "Dev mode",
    "Design tokens",
    "Canva",
    "FigJam",
    "Notion",
    "Miro",
  ],
  practice: [
    "User interviews",
    "Moderated usability testing",
    "Competitor analysis",
    "Affinity mapping",
    "Persona development",
    "Stakeholder communication",
    "Cross-functional collaboration",
    "Design critique & mentoring",
    "Strategic thinking",
  ],
};

export const experience = [
  {
    role: "User Experience Researcher",
    company: "TinyPal",
    period: "Mar 2026 — Present",
    location: "Remote",
    summary:
      "End-to-end UX research for an early-stage children’s education product. Recruit participants, design discussion guides, and turn qualitative findings into journey maps and onboarding decisions alongside the founders.",
  },
  {
    role: "Product Designer",
    company: "Pink Petals Design House",
    period: "Jun 2019 — Nov 2022",
    location: "Hyderabad · Hybrid",
    summary:
      "Led end-to-end product design for a fashion boutique — booking flows, digital catalogue and a bespoke staff-facing CRM. Owned the full Figma process from wireframes to developer handoff.",
  },
  {
    role: "ASE → UI/UX Designer",
    company: "IBM",
    period: "Mar 2014 — Jan 2018",
    location: "Hyderabad, India · Full-time",
    summary:
      "Began on IBM mainframe systems building deep technical knowledge of enterprise architecture, then transitioned internally into UI/UX — designing interfaces used by large-scale teams across IBM’s client organisations.",
  },
  {
    role: "Career Break · Upskilling",
    company: "AND Academy — PG Diploma in Product Design",
    period: "Mar 2023 — Nov 2024",
    location: "Hyderabad",
    summary:
      "Deliberate personal break followed by formal upskilling through AND Academy’s PG Diploma in Product Design.",
  },
];

export const education = [
  {
    degree: "PG Diploma in Product Design",
    school: "AND Academy · Hyderabad",
    period: "Nov 2024 — Jan 2026",
  },
  {
    degree: "Diploma in Design",
    school: "Hamstech Institute · Hyderabad",
    period: "2018 — 2019",
  },
  {
    degree: "B.Tech, Electrical & Electronics Engineering",
    school: "Jawaharlal Nehru Technological University · Kakinada",
    period: "2009 — 2013",
  },
];

export const recognition = [
  "Reduced task-logging time by 57% · Luvia",
  "Lifted task completion from 62% to 89% · FairMate",
  "Senior IBM Software Engineer → UI/UX Designer transition",
  "Independent design practice · 3+ years owner-operator",
];

// Real résumé PDF (download fallback) + page images (in-page viewer, can't be blocked)
export const resumeUrl = "/files/kavyasree-bysani-cv.pdf";
export const resumeImages = [
  "/resume-pages/p00.jpg",
  "/resume-pages/p01.jpg",
];
